import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";

const HOEScoreCard = ({ HOE = 0, target = 90 }) => {
  const value = Math.max(0, Math.min(HOE, target));
  const progress = (value / target) * 100;

  return (
    <Box
      sx={{
        background: "#2e7d32",
        borderRadius: 3,
        padding: 3,
        color: "#fff",
        boxShadow: "0px 8px 25px rgba(0,0,0,0.1)",
        width : "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      {/* Title + Icon */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        mb={2}
      >
        <Typography fontSize="16px" fontWeight={600} textAlign="left">
          HOE Scores
        </Typography>
        <EmojiEventsOutlinedIcon sx={{ color: "#fff", fontSize: 20 }} />
      </Box>

      {/* HOE Score */}
      <Box sx={{display:"flex", gap:"10px", mt:"6px"}}>
      <Typography
        fontSize="28px"
        fontWeight={700}
        textAlign="left"
        sx={{ lineHeight : 1 }}
      >
        {HOE}%
      </Typography>

      {/* Target Info */}
      {/* <Typography fontSize="14px" sx={{ opacity: 0.9 }} textAlign="left">
        Target: {target} ({progress < 100 ? "In Progress" : "Completed"})
      </Typography> */}
      </Box>

      {/* Progress Bar */}
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height : 8,
          borderRadius: 5,
          backgroundColor: "#ffffff55",
          width : "100%",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#a5f8b2",
          },
          mt: 2,
        }}
      />
    </Box>
  );
};

export default HOEScoreCard;